import { createElement } from 'react';
import { getErrorCopy } from '@/shared/copy/errors';
import { DataGridEmptyState, DATA_GRID_EMPTY_STATE_NO_DATA_LABEL } from './dataGridStates';
import type { ReactElement } from 'react';

type DataGridStateOptions = {
  emptyTitle?: string;
  emptyBody?: string;
  error?: boolean;
  errorTitle?: string;
  errorBody?: string;
  errorAction?: ReactElement;
};

type DataGridDefaults = {
  pageSizeOptions: number[];
  initialState: {
    pagination: { paginationModel: { page: number; pageSize: number } };
    sorting: { sortModel: [] };
  };
  slots: {
    noRowsOverlay: () => ReactElement;
    noResultsOverlay: () => ReactElement;
  };
  slotProps: { loadingOverlay: { variant: 'skeleton'; noRowsVariant: 'skeleton' } };
};

const renderEmptyState = (props: {
  title: string;
  body?: string;
  action?: ReactElement;
  variant?: 'default' | 'metricCard';
}): ReactElement => createElement(DataGridEmptyState, props);

export const getDataGridDefaults = (options: DataGridStateOptions = {}): DataGridDefaults => {
  const {
    emptyTitle = DATA_GRID_EMPTY_STATE_NO_DATA_LABEL,
    emptyBody,
    error = false,
    errorTitle = getErrorCopy('grid.errorTitle'),
    errorBody = getErrorCopy('grid.errorBody'),
    errorAction,
  } = options;

  const overlayProps = error
    ? { title: errorTitle, body: errorBody, action: errorAction, variant: 'default' as const }
    : { title: emptyTitle, body: emptyBody, variant: 'metricCard' as const };

  return {
    pageSizeOptions: [5, 10, 25, 50],
    initialState: {
      pagination: { paginationModel: { page: 0, pageSize: 5 } },
      sorting: { sortModel: [] },
    },
    slots: {
      noRowsOverlay: () => renderEmptyState(overlayProps),
      noResultsOverlay: () => renderEmptyState(overlayProps),
    },
    slotProps: { loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } },
  };
};

export type { DataGridDefaults, DataGridStateOptions };
